<template>
  <!-- 业务员审核 -->
  <div class="salesmanAudit">
    <!-- 面包屑导航 -->
    <!-- <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-plus" @click="handleEdit"
          >添加</el-button
        >
      </template>
    </crumbs-bar> -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['业务员管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-plus" @click="handleEdit('1')"
          >添加</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-select
          v-model="searchForm.Audit"
          style="width: 100px; margin-right: 10px"
        >
          <el-option value="99" label="全部"></el-option>
          <el-option value="0" label="已删除"></el-option>
          <el-option value="1" label="已禁用"></el-option>
          <el-option value="2" label="已启用"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="姓名"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
        <!-- <el-button type="primary" icon="el-icon-download" @click="getExport">导出</el-button> -->
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Name"
        label="用户名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="TelPhone"
        label="手机号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="Unit"
        label="单位"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Title"
        label="职称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Dept"
        label="科室"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="IDNumber"
        label="身份证号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="BankCardNumber"
        label="银行卡号"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PriceLevel"
        label="价格级别"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="AddTime"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="Status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="danger" plain v-if="scope.row.Status == '1'"
            >已禁用</el-tag
          >
          <el-tag type="primary" plain v-if="scope.row.Status == '2'"
            >已启用</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200px">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 1)"
            v-if="scope.row.Status == '2'"
            >禁用</el-button
          >
          <el-button
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 2)"
            v-if="scope.row.Status == '1'"
            >启用</el-button
          >

          <el-button
            type="warning"
            plain
            style="padding: 2px 3px"
            @click="resetPassword(scope.row)"
            >重置密码</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleTui(scope.row)"
            >推广码</el-button
          >
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="getCustomer(scope.row)"
            >患者列表</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <el-drawer
      :visible.sync="addDrawerVisible"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header" v-if="searchForm.department == '业务员'">
        复制业务员
      </div>
      <div class="drawer-header" v-if="searchForm.department == '开票员'">
        复制开票员
      </div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addDrawerYE"
            label-position="rigth"
            label-width="100px"
            ref="addForm"
          >
            <el-form-item
              label="业务员"
              prop="SalesMan"
              v-if="searchForm.department == '业务员'"
              style="margin-top: 50px"
            >
              <el-input
                v-model="addDrawerYE.SalesMan"
                clearable
                readonly
                style="width: 300px"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="开票员"
              prop="SalesMan"
              v-if="searchForm.department == '开票员'"
              style="margin-top: 50px"
            >
              <el-input
                v-model="addDrawerYE.SalesMan"
                clearable
                readonly
                style="width: 300px"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="选择复制人"
              prop="newSalesMan"
              style="margin-top: 50px"
            >
              <el-input
                v-model="addDrawerYE.newSalesMan"
                clearable
                style="width: 200px; margin-right: 10px"
                placeholder="请输入您常用的手机号"
              >
              </el-input>
              <el-button type="primary" @click="dialogTableVisible = true"
                >选择转让人</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="ScopeForm">确定</el-button>
        <el-button type="info" @click="addDrawerVisible = false"
          >取消</el-button
        >
      </div>
    </el-drawer>
    <el-dialog title="新建" :visible.sync="dialogTableVisible">
      <div class="zsekl">
        <el-select
          v-model="searchForm.department"
          style="width: 200px; margin-right: 10px"
        >
          <el-option value="开票员" label="开票员"></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 10px"
          clearable
          placeholder="业务员/开票员"
          v-model="searchForm.name"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach"
          >搜索</el-button
        >
      </div>
      <el-table
        :data="tableData"
        style="height: 300px; overflow-y: auto"
        @current-change="handleCurrentChange"
        border
      >
        <el-table-column label="序号" align="center" width="50">
          <template slot-scope="scope">
            <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="Name"
          label="用户名"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="TelPhone"
          label="手机号"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <pagination
          :allPage="allPage"
          :pageSize="pageSize"
          :currIndex="currPage"
          @hanSiChange="hanSiChange"
          @hanCurrChange="hanCurrChange"
        ></pagination>
      </el-table>
      <pagination
        :allPage="allPage"
        :pageSize="pageSize"
        :currIndex="currPage"
        @hanSiChange="hanSiChange"
        @hanCurrChange="hanCurrChange"
      ></pagination>
    </el-dialog>
    <!-- 编辑业务员信息 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑医生信息</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="100px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="手机号：" prop="UserName">
              <el-input
                v-model="addForm.UserName"
                clearable
                style="width: 300px"
                placeholder="请输入您常用的手机号"
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="登录密码："
              prop="PassWord"
              v-if="addForm.id == ''"
            >
              <el-input
                v-model="addForm.PassWord"
                clearable
                style="width: 300px"
                placeholder="请输入您的登录密码"
                show-password
              >
              </el-input>
            </el-form-item>
            <el-form-item
              label="确认密码："
              v-if="addForm.id == ''"
              prop="ConfirmPassword"
            >
              <el-input
                v-model="addForm.ConfirmPassword"
                clearable
                style="width: 300px"
                placeholder="请再次输入密码"
                show-password
              >
              </el-input>
            </el-form-item>
            <el-form-item label="真实姓名：" prop="Name">
              <el-input
                v-model="addForm.Name"
                clearable
                style="width: 300px"
                placeholder="请输入您的真实姓名"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="身份证号：" prop="IDNumber">
              <el-input
                v-model="addForm.IDNumber"
                clearable
                style="width: 300px"
                placeholder="请输入您的身份证号"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="区域：" prop="areaValue">
              <el-cascader
                style="width: 300px"
                :props="{
                  // multiple: true,
                  checkStrictly: true,
                  emitPath: false,
                }"
                v-model="addForm.areaValue"
                :options="$store.state.citys"
              ></el-cascader>
            </el-form-item>

            <el-form-item label="部门:" prop="Department">
              <el-select v-model="addForm.Department" style="width: 300px">
                <el-option
                  v-for="(role, index) in Department"
                  :key="index"
                  :label="role.dept_name"
                  :value="role.dept_name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位：" prop="Unit">
              <el-input
                v-model="addForm.Unit"
                clearable
                style="width: 300px"
                placeholder="请输入您的单位"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="职称：" prop="Title">
              <el-input
                v-model="addForm.Title"
                clearable
                style="width: 300px"
                placeholder="请输入您的职称"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="科室：" prop="Dept">
              <el-input
                v-model="addForm.Dept"
                clearable
                style="width: 300px"
                placeholder="请输入您的科室"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="价格级别:" prop="PriceLevel">
              <el-input
                v-model="addForm.PriceLevel"
                clearable
                style="width: 300px"
                @focus="blurLenver"
                placeholder="请选择价格级别"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="银行卡号:" prop="BankCardNumber">
              <el-input
                v-model="addForm.BankCardNumber"
                clearable
                style="width: 300px"
                placeholder="请输入银行卡号"
              >
              </el-input>
            </el-form-item>
            <el-form-item label="请选择业务员:" prop="Referrer">
              <el-select v-model="addForm.Referrer" style="width: 300px">
                <el-option
                  v-for="(role, index) in SalelistData"
                  :key="index"
                  :label="role.Name"
                  :value="role.UserId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="图片:" prop="PriceLevel">
              <div v-for="(item, index) in Certificates" :key="index">
                <p style="color: red">{{ item.certificate_name }}</p>
                <upload
                  @fileChange="uploadSortImg($event, index)"
                  accept="image/jpg,image/jpeg,image/png"
                  :multiple="true"
                ></upload>
                <img-view
                  style="margin-left: 20px"
                  :imgList="[{ url: item.img, id: 0 }]"
                ></img-view>
                <div>
                  750px*400px，该图片显示模式为裁剪模式，主内容应显示在中间，两边为填充区
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm" v-if="addForm.id == ''"
          >确定</el-button
        >
        <el-button type="primary" @click="EditForm" v-else>确定</el-button>
        <el-button type="info" @click="closeForm">取消</el-button>
      </div>
    </el-drawer>

    <tableDialog
      v-if="dialogVisible"
      title="角色选择"
      :searchValue="searchFormRole.name"
      :tableData="tableList"
      :tableHead="tableHead"
      :currPage.sync="currPageRole"
      :allPage="allPageRole"
      @search="getRoleList"
      @rowClick="rowClick"
      @close="dialogVisible = false"
    ></tableDialog>
    <!-- 价格等级 -->
    <tableDialog
      v-if="isPriceLevel"
      :title="'价格等级'"
      :searchValue="priceLevelSearch.name"
      :tableData="priceLevleList"
      :tableHead="priceLevleHead"
      :currPage.sync="priceLevlePage"
      :pageSize.sync="pageSizeData"
      :allPage="priceLevleAll"
      @search="getPriceLevel"
      @rowClick="setPriceLevle"
      @hanCurrChange="setPriceLevelPage"
      @hanSizesChange="hanSizesChange"
      @close="isPriceLevel = false"
    ></tableDialog>
    <el-dialog title="推广码" :visible.sync="TuiVisible" width="20%">
      <div
        style="
          width: 200px;
          height: 300px;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <img
          :src="TuiImg"
          alt=""
          style="width: 200px; height: 200px"
          srcset=""
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "SalesmanListDoict",
  data() {
    return {
      /**表格数据 */
      //序号	单位	用户名	真实姓名	手机号	创建日期	状态	操作
      tableData: [
        {
          unit: "单位",
          userName: "用户名",
          realName: "真实姓名",
          tel: "手机号",
          createTime: "创建日期",
          status: "状态",
        },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        name: "",
        Audit: "99",
        department: "",
        salemanId: "",
      },
      status: "",
      SaleManId: "",
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        Certificates: [],
        UserName: "18865978544", //用户名 与 手机号保持一致
        PassWord: "123456", //密码
        ConfirmPassword: "",
        Name: "王医生", //姓名
        Telphone: "18865978544", //手机号
        Department: "公司", //部门
        RoleType: 2, //人员类型  固定值   2
        Referrer: "YWP00000037", //医生注册需要推荐人：业务员
        Unit: "某某医院", //单位
        Title: "主任医师", //职称
        Dept: "骨科", //科室
        IDNumber: "723587199611243215", //身份证号
        BankCardNumber: "56878984568955426656", //银行卡号
        PriceLevel: "JG0001", //价格级别
        AreaCode: "4101", //区域编号
      },
      Certificates: [
        {
          certificate_name: "胸牌", //身份证正面/身份证反面
          certificate_img: "",
          img: "",
        },
      ],
      addFormRule: {
        PassWord: [mustFill],
        ConfirmPassword: [mustFill],
        Name: [mustFill],
        areaValue: "",
        Department: [mustFill], //部门/类型
        RoleType: [mustFill],
        IDNumber: [mustFill],
        PriceLevel: [mustFill],
      },
      // 选择数据弹框
      dialogVisible: false,
      currPageRole: 1,
      allPageRole: 0,
      searchFormRole: {
        id: "",
        entId: "",
        name: "",
      },
      tableList: [],
      Department: [], //部门列表
      tableHead: {},
      // 转让业务员
      addDrawerVisible: false,
      dialogTableVisible: false,
      addDrawerYE: {
        newSalesMan: "", // 手机号
        newSalesManId: "", // 登录密码
        SalesManId: "",
        SalesMan: "",
      },
      // 价格等级相关
      priceLevelUserId: "", // 价格等级绑定的用户编号
      isPriceLevel: false,
      priceLevleList: [],
      priceLevleHead: {},
      priceLevelSearch: {
        name: "",
      },
      priceLevlePage: 1,
      pageSizeData: 10,
      priceLevleAll: 0,
      id: "",

      SalelistData: [], //业务员列表
      // 推广码
      TuiVisible: false,
      TuiImg: "",
    };
  },
  created() {
    this.seach();
  },
  components: {},
  mounted() {
    // if (this.$route.query.prams) {
    //   let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    //   if (prams) {
    //     this.id = prams;
    //     this.getTableData();
    //     this.getDepartment();
    //   }
    // }
  },
  methods: {
    seach() {
      this.getTableData();
      this.getDepartment();
      this.getSalelist();
    },
    blurLenver() {
      this.getPriceLevel();
    },
    // 设置客户价格数据
    setPriceLevle(row) {
      console.log(row);
      this.addForm.PriceLevel = row.id;
      this.isPriceLevel = false;
    },
    // 上传分类图片
    uploadSortImg(file, index) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.Certificates[index].certificate_img = res.message;
              this.Certificates[index].img = this.$setImgUrl(res.message);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 推广码
    handleTui(row) {
      // this.TuiVisible = true;
      // console.log(row);
      let data = {
        UserId: row.UserId,
        env_version: "trial", //小程序打开页面链接
      };
      this.$request({
        url: "/Management/DoctorAdmin/PromotionCode",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.TuiVisible = true;
          this.TuiImg = this.$setImgUrl(res.dataModel);
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 获取机构等级
    getPriceLevel(val, isRep) {
      this.priceLevelSearch.name = isRep ? val : this.priceLevelSearch.name;
      let data = {
        entId: window.localStorage.getItem("entId"),
        searchVal: this.priceLevelSearch.name,
        pageIndex: this.priceLevlePage,
        pageSize: this.pageSizeData,
      };
      this.$request({
        method: "post",
        url: "GoodsAdmin/GetPriceLevel",
        data: data,
      })
        .then((res) => {
          this.priceLevleList = [];
          this.priceLevleAll = 0;
          if (res.success) {
            this.priceLevleAll = res.toTal;
            this.priceLevleList = (res.list || []).map((item) => ({
              id: item.PriceCode, // 价格等级编号
              name: item.PriceName, // 价格等级名称
            }));
            this.priceLevleHead = { id: "价格等级编号", name: "价格等级名称" };
            this.isPriceLevel = true;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取业务员数据 */
    getSalelist() {
      let data = {
        roleType: "1",
        pageInde: 1,
        pageSize: 9999,
        status: 2,
      };
      this.$request({
        url: "/Management/SalesManAdmin/GetSalesManList",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.SalelistData = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
          this.allPage = 0;
        });
    },
    // 设置价格等级列表页码
    setPriceLevelPage(val) {
      this.priceLevlePage = val;
      this.getPriceLevel();
    },
    // 设置价格等级列表页码
    hanSizesChange(val) {
      this.pageSizeData = val;
      this.getPriceLevel();
    },
    // 获取部门
    getDepartment() {
      this.$request({
        url: "Management/DepartmentAdmin/DepartmentList",
        method: "post",
        data: {
          pageIndex: 1,
          pageSize: 100,
        },
      })
        .then((res) => {
          if (res.success) {
            this.Department = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**获取数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        valStr: this.searchForm.name,
        status: this.searchForm.Audit,
        roleType: 2,
        pageInde: this.currPage,
        pageSize: this.pageSize,
      };
      this.$request({
        url: "/Management/DoctorAdmin/GetDoctorList",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dataList;
            this.allPage = res.recordCount;
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
            this.allPage = 0;
          }
        })
        .catch((err) => {
          window.console.log(err);
          this.allPage = 0;
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    //导出
    getExport() {
      // var list=JSON.stringify(data)
      // window.location.href = "http://117.21.178.60/api/Order/NoPIGExprot?json=" + list + "&proc=Proc_SaleMan"  + "&name=业务员";

      // let data = {
      // 	type: "GetSalesManList",
      //   userId: window.localStorage.getItem('userId'),
      //   entId: window.localStorage.getItem('entId'),
      // 	status: this.Audit,
      // 	strWhere: this.name,
      // 	PageIndex: 1,
      // 	PageSize: 999999,
      // }
      // let proc = "Proc_SaleMan" // 存储过程名
      // window.location.href = this.baseUrl + "Order/NoPIGExprot?json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + encodeURIComponent(proc) + "&name=业务员"
      let data = {
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        status: "9",
        queryWhere: "",
        PageIndex: 1,
        PageSize: 999999,
      };
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&name=业务员";
    },
    // 禁用
    getDisable(list) {
      this.$confirm("是否禁用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.status = "1";
          this.SaleManId = list.UserId;
          this.EnableDisable();
        })
        .catch(() => {
          this.$message.info("取消禁用！");
        });
    },

    //启用
    getEnable(list) {
      this.$confirm("是否启用?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.status = "2";
          this.SaleManId = list.UserId;
          this.EnableDisable();
        })
        .catch(() => {
          this.$message.info("取消启用！");
        });
    },

    EnableDisable() {
      let data = {
        entId: window.localStorage.getItem("entId"),
        ywyid: this.SaleManId,
        status: this.status,
      };
      this.$request({
        url: "SalesMan/UpdateSalesManStatus",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 转让业务员确定
    ScopeForm() {
      if (this.addDrawerYE.newSalesManId == "") {
        this.$message({
          message: "复制人不能不能为空",
          type: "warning",
        });
        return;
      }
      if (this.addDrawerYE.SalesManId == this.addDrawerYE.newSalesManId) {
        this.$message({
          message: "复制人不能和原业务员/开票员相同",
          type: "warning",
        });
        return;
      }
      let data = {
        salesManId: this.addDrawerYE.SalesManId,
        mainSalesManId: this.addDrawerYE.newSalesManId,
      };
      this.$request({
        url: "/Management/SalesManAdmin/CopySalemsManGoods",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
          } else {
            //失败提示
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            userId: row.UserId,
            status: status, // 0 删除 1 禁用 2 启用
          };
          this.$request({
            url: "/Management/SalesManAdmin/AuditSalesMan",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.getTableData();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    // 确定重置密码吗
    resetPassword(row) {
      this.$confirm("确定重置密码吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          let data = {
            userId: row.UserId,
          };
          this.$request({
            url: "/Management/SalesManAdmin/ResetPassWord",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.closeForm();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    //绑定客户
    getCustomer(list) {
      let prams = null;
      if (list) {
        prams = encodeURIComponent(JSON.stringify(list));
      } else {
        prams = list;
      }
      this.$router.push({
        path: "DoictSickLits",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    //绑定商品
    getCommodity(list) {
      let prams = null;
      if (list) {
        prams = encodeURIComponent(JSON.stringify(list));
      } else {
        prams = list;
      }
      console.log(prams, "chuznzhi");
      this.$router.push({
        path: "SalesmanCommodity",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
    /**绑定分组 */
    handleBind(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify(row));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "bindGroup",
        query: {
          row: prams,
        },
      });
      prams = null;
    },
    /**新增/编辑分类 */
    handleEdit(row) {
      console.log(row, "1111111111111111");
      this.closeForm();
      if (row !== "1") {
        this.$request({
          url: "Management/DoctorAdmin/GetDoctorInfo",
          method: "post",

          data: {
            UserId: row.UserId,
          },
        }).then((res) => {
          if (res.success) {
            this.Certificates = [];
            this.addForm.UserName = res.dataModel.Telphone; //用户名 与 手机号保持一致
            this.addForm.PassWord = res.dataModel.PassWord; //密码
            this.addForm.ConfirmPassword = res.dataModel.PassWord;
            this.addForm.Name = res.dataModel.Name; //姓名
            this.addForm.Telphone = res.dataModel.Telphone; //手机号
            this.addForm.Department = res.dataModel.Department; //部门
            this.addForm.RoleType = res.dataModel.RoleType; //人员类型  固定值   2
            this.addForm.Referrer = res.dataModel.Referrer; //医生注册需要推荐人：业务员
            this.addForm.Unit = res.dataModel.Unit; //单位
            this.addForm.Title = res.dataModel.Title; //职称
            this.addForm.Dept = res.dataModel.Dept; //科室
            this.addForm.IDNumber = res.dataModel.IDNumber; //身份证号
            this.addForm.BankCardNumber = res.dataModel.BankCardNumber; //银行卡号
            this.addForm.PriceLevel = res.dataModel.PriceLevel; //价格级别
            this.addForm.AreaCode = res.dataModel.AreaCode; //区域编号
            this.addForm.id = (res.dataModel.UserId || "").trim();
            res.dataModel.Certificates.forEach((item) => {
              this.Certificates.push({
                certificate_name: item.certificate_name, //身份证正面/身份证反面
                certificate_img: item.certificate_img,
                img: this.$setImgUrl(item.certificate_img),
              });
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
        //   console.log(row);
      }
      this.addDrawer = true;
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    handleScope(row) {
      this.closeScope();
      if (row) {
        this.addDrawerYE.SalesManId = row.UserId;
        this.addDrawerYE.SalesMan = row.Name;
      }
      this.addDrawerVisible = true;
    },
    closeScope() {
      for (let key in this.addDrawerYE) {
        this.addDrawerYE[key] = "";
      }
      this.addDrawerVisible = false;
    },
    handleCurrentChange(row) {
      this.addDrawerYE.newSalesMan = row.Name;
      this.addDrawerYE.newSalesManId = row.UserId;
      this.dialogTableVisible = false;
    },
    /**关闭drawer 清空表单信息 */
    closeForm() {
      for (let key in this.addForm) {
        this.addForm[key] = "";
      }
      this.addDrawer = false;
    },

    // 添加业务员
    /**提交表单 */
    submitForm() {
      let Certificates = [];
      this.Certificates.forEach((item) => {
        Certificates.push({
          certificate_name: item.certificate_name, //身份证正面/身份证反面
          certificate_img: item.certificate_img,
        });
      });
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            UserName: this.addForm.UserName, //用户名 与 手机号保持一致
            PassWord: this.addForm.PassWord, //密码
            Name: this.addForm.Name, //姓名
            Telphone: this.addForm.UserName, //手机号
            Department: this.addForm.Department, //部门
            RoleType: 2, //人员类型  固定值   2
            Referrer: this.addForm.Referrer, //医生注册需要推荐人：业务员
            Unit: this.addForm.Unit, //单位
            Title: this.addForm.Title, //职称
            Dept: this.addForm.Dept, //科室
            IDNumber: this.addForm.IDNumber, //身份证号
            BankCardNumber: this.addForm.BankCardNumber, //银行卡号
            PriceLevel: this.addForm.PriceLevel, //价格级别
            AreaCode: this.addForm.AreaCode, //区域编号
            Certificates: Certificates,
          };
          console.log(data, "测试");
          this.$request({
            url: "/Management/DoctorAdmin/CreateDoctor",
            headers: {
              Auth: window.localStorage.getItem("auth"),
              ContentType: "application/json",
            },
            method: "post",
            data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.closeForm();
                this.handleRefresh();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**提交表单 */
    EditForm() {
      let Certificates = [];
      this.Certificates.forEach((item) => {
        Certificates.push({
          certificate_name: item.certificate_name, //身份证正面/身份证反面
          certificate_img: item.certificate_img,
        });
      });
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            UserName: this.addForm.UserName, //用户名 与 手机号保持一致
            PassWord: this.addForm.PassWord, //密码
            Name: this.addForm.Name, //姓名
            Telphone: this.addForm.UserName, //手机号
            Department: this.addForm.Department, //部门
            RoleType: 2, //人员类型  固定值   2
            Referrer: this.addForm.Referrer, //医生注册需要推荐人：业务员
            Unit: this.addForm.Unit, //单位
            Title: this.addForm.Title, //职称
            Dept: this.addForm.Dept, //科室
            IDNumber: this.addForm.IDNumber, //身份证号
            BankCardNumber: this.addForm.BankCardNumber, //银行卡号
            PriceLevel: this.addForm.PriceLevel, //价格级别
            AreaCode: this.addForm.AreaCode, //区域编号
            Certificates: Certificates,
            UserId: this.addForm.id,
          };
          this.$request({
            url: "/Management/DoctorAdmin/ModifyDoctorInfo",
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.closeForm();
                this.handleRefresh();
              } else {
                //失败提示
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    // 业务员绑定角色
    /**绑定区域 */
    bindRole(row) {
      this.searchFormRole.id = row.UserId;
      this.searchFormRole.entId = row.EntId;
      this.getRoleList("");
    },

    // 获取角色
    getRoleList(val, isRep) {
      this.searchFormRole.name = isRep ? val : this.searchFormRole.name;
      let data = {
        type: "GetYwtRole",
        spid: this.searchFormRole.id,
        xentId: this.searchFormRole.entId,
        strWhere: this.searchFormRole.name,
        PageIndex: this.currPageRole,
        PageSize: 10,
      };
      let proc = "proc_dkxd_salesman"; // 存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.tableList = res.content;
            this.tableHead = res.fdname;
            this.allPageRole = res.recordCount;
            this.dialogVisible = true;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 选择单条数据 绑定角色
    rowClick(row) {
      let data = {
        type: "UpdateSalesManRole",
        keyid: row.KeyId,
        ywyid: this.searchFormRole.id,
        xentId: this.searchFormRole.entId,
      };
      let proc = "proc_dkxd_salesman"; // 存储过程名
      let type = "ReturnNumber";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
            this.dialogVisible = false;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.salesmanAudit {
  width: 100%;
  height: 100%;
}
.zsekl {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
